const loadAll = function (vm) {
    return vm.$loading({
        url: "/api/document/customer/getSeller",
        // params: {
        //     number: 1,
        //     size: 100
        // }
    }).then(function (res) {
        if (res.success) {
            return res.data;
        } else {
            vm.$weui.topTips(res.message, 2000);
        }
    });
};

/**
 * 币种筛选
 */
export default {
    init(filter) {
        filter.value = null;
    },
    handler(filter, vm) {
        loadAll(vm).then(function (data) {
            var options = data.map(o => {
                return Object.assign(o, {
                    label: o,
                    value: o
                });
            });
            options.unshift({ label: '全部', value: null })
            vm.$weui.picker(options, {
                defaultValue: [filter.value],
                onConfirm: function (result) {
                    if (result.length) {
                        filter.value = result[0].value;
                        vm.onChange(filter);
                    }
                }
            });
        });
    },
    renderer(filter) {
        return filter.value ? filter.value : '全部' ;
    },
    fn(value, filter) {
        return {
            type: "enum",
            field: filter.name,
            operation: "in",
            value: "'" + value + "'"
        };
    }
}